export enum FormField {
  owner_id = 'owner_id',
  project = 'project',
  country = 'country',
  city = 'city',
  address = 'address',
  postcode = 'postcode',
  map = 'map',
  notes = 'notes',
}